export default __webpack_public_path__ + "static/media/crop-selected.f7599815.svg";